"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const match_1 = require("../match");
const hooks_1 = require("../hooks");
const searchParams_1 = __importDefault(require("../url/searchParams"));
const Route = ({ match, path, children }) => {
    const matcher = (0, react_1.useMemo)(() => new match_1.Matcher(path), [path]);
    const location = (0, hooks_1.useLocation)();
    match !== null && match !== void 0 ? match : (match = matcher.match(location));
    if (!match || !children)
        return null;
    const props = {
        location,
        match,
        query: new searchParams_1.default(location.search).content,
    };
    if (!Array.isArray(children))
        return renderChild(children, props);
    return children.map((child, key) => renderChild(child, Object.assign({ key }, props)));
};
const renderChild = (child, props) => typeof child === 'function' ||
    (typeof child === 'object' && !react_1.default.isValidElement(child))
    ? react_1.default.createElement(child, props)
    : child;
exports.default = Route;
